import { connect } from 'react-redux';
import { RootState, Dispatch } from 'shared/state';
import {
  closePublishNoteDialog,
  selectPublishNoteOpen,
} from 'shared/state/ducks/ui';
import PublishNoteDialog from './PublishNoteDialog';
import { publishSite } from 'shared/state/ducks/sites';

const mapStateToProps = (state: RootState) => ({
  open: selectPublishNoteOpen()(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClose: () => {
    dispatch(closePublishNoteDialog());
  },
  publishSite: (siteId: number, publishMessage: string) => {
    dispatch(publishSite(siteId, publishMessage));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishNoteDialog);
